module['exports'] = [
  'Acquadro',
  'Acquistapace',
  'Adami',
  'Addis',
  'Agostinelli',
  'Aiello',
  'Alaimo',
  'Alberti',
  'Amadori',
  'Amato',
  'Amerio',
  'Amico',
  'Andrisani',
  'Anelli',
  'Angelini',
  'Angelucci',
  'Arena',
  'Asaro',
  'Atzeni',
  'Azara',
  'Babini',
  'Bacci',
  'Baggio',
  'Balboni',
  'Baldi',
  'Baldini',
  'Ballarin',
  'Bandini',
  'Baraldi',
  'Barbera',
  'Barberis',
  'Barbero',
  'Barbieri',
  'Barsotti',
  'Bartolini',
  'Bartolucci',
  'Basile',
  'Basso',
  'Battaglia',
  'Battistini',
  'Bellini',
  'Bellucci',
  'Belotti',
  'Beltrame',
  'Beltrami',
  'Benatti',
  'Benedetti',
  'Benini',
  'Benvenuti',
  'Beretta',
  'Bernardini',
  'Bernasconi',
  'Bertini',
  'Berto',
  'Bertolini',
  'Bertolussi',
  'Betti',
  'Biagini',
  'Biancheri',
  'Bianchi',
  'Bianco',
  'Bini',
  'Bionaz',
  'Bisio',
  'Blanc',
  'Bocchi',
  'Bodini',
  'Bonato',
  'Borghi',
  'Bortolin',
  'Bortoluzzi',
  'Bortot',
  'Boscolo',
  'Brambilla',
  'Bresciani',
  'Bressan',
  'Briano',
  'Brogi',
  'Brumat',
  'Bruni',
  'Bruno',
  'Bruzzone',
  'Bucci',
  'Calligaris',
  'Cammarata',
  'Campanini',
  'Campisi',
  'Campoli',
  'Canepa',
  'Cannone',
  'Canova',
  'Canu',
  'Capasso',
  'Capecchi',
  'Cappelli',
  'Cappello',
  'Capriotti',
  'Caputo',
  'Careddu',
  'Caretti',
  'Carini',
  'Carletti',
  'Carlucci',
  'Carminati',
  'Carnovale',
  'Carrara',
  'Carraro',
  'Carrieri',
  'Carrozzo',
  'Carta',
  'Caruso',
  'Carvelli',
  'Casadei',
  'Casadio',
  'Casagrande',
  'Cascone',
  'Casini',
  'Cassano',
  'Castiglioni',
  'Catellani',
  'Cattaneo',
  'Cavallari',
  'Cavalli',
  'Cavallo',
  'Ceccarelli',
  'Cecchi',
  'Cecchini',
  'Cerise',
  'Cerrani',
  'Cerrato',
  'Cerutti',
  'Ciavarella',
  'Cingolani',
  'Ciuffreda',
  'Colangelo',
  'Colombo',
  'Colonna',
  'Colucci',
  'Concas',
  'Conte',
  'Conti',
  'Coppola',
  'Corazza',
  'Cordioli',
  'Corradi',
  'Corridori',
  'Corti',
  'Cortinovis',
  'Coslovich',
  'Cossu',
  'Costa',
  'Costantini',
  'Coviello',
  'Cozzani',
  'Cozzolino',
  'Crea',
  'Cremonesi',
  'Crepaldi',
  'Crespi',
  'Crevatin',
  'Crippa',
  "D'Agostino",
  "D'Alessandro",
  "D'Amico",
  "D'Andrea",
  "D'Angelo",
  "D'Incà",
  "D'Orazio",
  'Da Rold',
  'Dal Farra',
  'Dalmasso',
  'Davoli',
  'De Angelis',
  'De Bona',
  'De Col',
  'De Giorgi',
  'De Luca',
  'De Lucia',
  'De Maio',
  'De Marco',
  'De Palma',
  'De Rosa',
  'De Santis',
  'Degano',
  'Degrassi',
  'Deiana',
  'Delfino',
  "Dell'Amico",
  'Demurtas',
  'Denti',
  'Di Bari',
  'Di Carlo',
  'Di Cesare',
  'Di Dio',
  'Di Domenico',
  'Di Felice',
  'Di Francesco',
  'Di Giovanni',
  'Di Girolamo',
  'Di Giuseppe',
  'Di Iorio',
  'Di Marco',
  'Di Matteo',
  'Di Mauro',
  'Di Nardo',
  'Di Paolo',
  'Di Pietro',
  'Di Stefano',
  'Diana',
  'Donati',
  'Donda',
  'Doronzo',
  'Dragoni',
  'Dutto',
  'Egger',
  'Epifani',
  'Ercoli',
  'Esposito',
  'Fabbri',
  'Fabbro',
  'Fabris',
  'Falzone',
  'Fanelli',
  'Fasoli',
  'Favaro',
  'Favero',
  'Favre',
  'Ferluga',
  'Ferracuti',
  'Ferrando',
  'Ferrara',
  'Ferrari',
  'Ferrario',
  'Ferraris',
  'Ferraro',
  'Ferrarotti',
  'Ferrero',
  'Ferretti',
  'Ferri',
  'Ferro',
  'Festuccia',
  'Filippi',
  'Filippini',
  'Finotti',
  'Fioravanti',
  'Fiore',
  'Fiorini',
  'Fiorucci',
  'Floris',
  'Fonda',
  'Fontana',
  'Fornara',
  'Forte',
  'Foschi',
  'Foti',
  'Francese',
  'Franco',
  'Franzoni',
  'Franzè',
  'Frigerio',
  'Frigo',
  'Fumagalli',
  'Fumarola',
  'Furlan',
  'Fusco',
  'Gabriele',
  'Gabrielli',
  'Gagliano',
  'Galati',
  'Galli',
  'Gallo',
  'Gamberini',
  'Gambino',
  'Gamper',
  'Garau',
  'Garavaglia',
  'Gargiulo',
  'Gasser',
  'Gatti',
  'Gazzola',
  'Genna',
  'Gentile',
  'Gentili',
  'Giacalone',
  'Giannini',
  'Gigliotti',
  'Giordano',
  'Giovannini',
  'Giraudo',
  'Giuffrida',
  'Giuliani',
  'Giunta',
  'Giusti',
  'Gori',
  'Govoni',
  'Granata',
  'Grandi',
  'Grange',
  'Grasso',
  'Greco',
  'Gregori',
  'Greppi',
  'Grieco',
  'Grillo',
  'Grossi',
  'Gruber',
  'Guarneri',
  'Guastella',
  'Guastone',
  'Guerra',
  'Guerriero',
  'Guerrini',
  'Guglielmi',
  'Guidi',
  'Gurrieri',
  'Gusmeroli',
  'Hofer',
  'Huber',
  'Iacono',
  'Iannaccone',
  'Ierardi',
  'Iezzi',
  'Innocenti',
  'Iotti',
  'Izzi',
  'Izzo',
  'Kofler',
  'Laganà',
  'Lai',
  'Landi',
  'Lanteri',
  'Lanza',
  'Lenzi',
  'Leonardi',
  'Leone',
  'Leonetti',
  'Licata',
  'Licitra',
  'Ligorio',
  'Liverani',
  'Locatelli',
  'Lodi',
  'Loi',
  'Lombardi',
  'Lombardo',
  'Lonardi',
  'Longo',
  'Lorusso',
  'Lovato',
  'Lucchesi',
  'Luciani',
  'Lugli',
  'Luppi',
  'Macchi',
  'Maggi',
  'Maggiani',
  'Magnani',
  'Maio',
  'Mair',
  'Malagoli',
  'Malavasi',
  'Manca',
  'Mancini',
  'Mancuso',
  'Manetti',
  'Manfredi',
  'Mantovani',
  'Marangon',
  'Marchesan',
  'Marchetti',
  'Marcon',
  'Marconi',
  'Marega',
  'Marelli',
  'Mariani',
  'Marinelli',
  'Marini',
  'Marino',
  'Martinelli',
  'Martini',
  'Martino',
  'Marziali',
  'Masiero',
  'Massaro',
  'Mastroianni',
  'Matera',
  'Mauro',
  'Mazza',
  'Mazzeo',
  'Mazzocchi',
  'Mazzoleno',
  'Mazzoni',
  'Mazzotti',
  'Mecca',
  'Medeot',
  'Melandri',
  'Melis',
  'Meloni',
  'Menconi',
  'Menegatti',
  'Menna',
  'Menozzi',
  'Mereu',
  'Merola',
  'Messina',
  'Miglio',
  'Mignogna',
  'Milan',
  'Milani',
  'Minniti',
  'Moffa',
  'Molinari',
  'Molteni',
  'Monaci',
  'Montagna',
  'Montalbano',
  'Montanari',
  'Montemurro',
  'Monti',
  'Mora',
  'Morabito',
  'Morandi',
  'Moras',
  'Morelli',
  'Moretti',
  'Moro',
  'Morri',
  'Mosca',
  'Moser',
  'Mosti',
  'Mura',
  'Murgia',
  'Murru',
  'Musso',
  'Nanni',
  'Napolitano',
  'Natale',
  'Negri',
  'Neri',
  'Nesti',
  'Niccolai',
  'Nicoletti',
  'Nobili',
  'Nocentini',
  'Occhipinti',
  'Pace',
  'Pacini',
  'Palladino',
  'Palmisani',
  'Palmisano',
  'Palumbo',
  'Panzeri',
  'Paolicelli',
  'Paolucci',
  'Pappalardo',
  'Pardini',
  'Parente',
  'Parisi',
  'Parodi',
  'Parrinello',
  'Pastorino',
  'Pavan',
  'Peaquin',
  'Pedrazzini',
  'Pedrotti',
  'Pellegrini',
  'Pellegrino',
  'Penzo',
  'Pepe',
  'Perego',
  'Perri',
  'Perrone',
  'Pession',
  'Petrarca',
  'Petronio',
  'Piana',
  'Pianigiani',
  'Piazzolla',
  'Picariello',
  'Picco',
  'Pichler',
  'Pieri',
  'Pini',
  'Pinna',
  'Pintus',
  'Pipitone',
  'Piras',
  'Pircher',
  'Piscitelli',
  'Pivetta',
  'Poggio',
  'Poletti',
  'Porcu',
  'Pozzo',
  'Prencipe',
  'Privitera',
  'Procopio',
  'Proietti',
  'Pucci',
  'Pugliese',
  'Puglisi',
  'Quaranta',
  'Quarta',
  'Quinto',
  'Rallo',
  'Ramella',
  'Rampazzo',
  'Randazzo',
  'Rapisarda',
  'Ravaioli',
  'Rea',
  'Redaelli',
  'Repetto',
  'Ricci',
  'Riggi',
  'Righetti',
  'Righi',
  'Rinaldi',
  'Riva',
  'Rizza',
  'Rizzi',
  'Rizzo',
  'Rocca',
  'Rodigari',
  'Romagnoli',
  'Romaniello',
  'Romano',
  'Romeo',
  'Rosati',
  'Rosset',
  'Rossi',
  'Rosso',
  'Rota',
  'Ruggeri',
  'Ruggiero',
  'Russo',
  'Sabatini',
  'Sabbatini',
  'Sabia',
  'Sacchet',
  'Sacchi',
  'Sacco',
  'Sala',
  'Salvadori',
  'Salvatore',
  'Salvucci',
  'Sanfilippo',
  'Sanna',
  'Santarelli',
  'Santarossa',
  'Santarsiero',
  'Santilli',
  'Santini',
  'Santoro',
  'Saponaro',
  'Sartor',
  'Sartori',
  'Sbrana',
  'Scalise',
  'Scarpa',
  'Scherini',
  'Schiavi',
  'Schiavon',
  'Sechi',
  'Semeraro',
  'Semprini',
  'Senatore',
  'Serafini',
  'Serra',
  'Silenzi',
  'Silvestri',
  'Siri',
  'Sorrentino',
  'Spano',
  'Spina',
  'Stigliano',
  'Sucera',
  'Surace',
  'Tagliabue',
  'Tagliaferri',
  'Talarico',
  'Tallarico',
  'Tanzi',
  'Tassone',
  'Telesca',
  'Tesi',
  'Testa',
  'Tiozzo',
  'Tomasi',
  'Tonelli',
  'Torchio',
  'Torresi',
  'Torrisi',
  'Totaro',
  'Traini',
  'Traverso',
  'Trevisan',
  'Tripodi',
  'Trovato',
  'Tumino',
  'Usai',
  'Vailati',
  'Valentini',
  'Valsecchi',
  'Vascotto',
  'Vella',
  'Venezia',
  'Venturelli',
  'Venturi',
  'Venturini',
  'Vercesi',
  'Veronese',
  'Vezzoli',
  'Viale',
  'Vianello',
  'Vichi',
  'Vierin',
  'Villa',
  'Vincenzi',
  'Visentin',
  'Visintin',
  'Vitale',
  'Vitali',
  'Vuillermoz',
  'Zagaria',
  'Zanatta',
  'Zanella',
  'Zanetta',
  'Zanetti',
  'Zani',
  'Zeni',
  'Zennaro',
  'Zordan',
  'Zuliani',
  'Zunino'
];
